import React, { useState } from 'react'
import { IconButton, Drawer, makeStyles } from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import MainNavigationList from 'components/Navigation/MainNavigationList'

const useStyles = makeStyles((theme) => ({
  mobileMenuList: {
    width: '15rem'
  }
}))

export default function MobileNavigation() {
  const [showDrawer, setShowDrawer] = useState(false)
  const classes = useStyles()

  return (
    <React.Fragment>
      <Drawer onClose={() => setShowDrawer(false)} anchor='left' open={showDrawer}>
        <div className={classes.mobileMenuList} onClick={() => setShowDrawer(false)}>
          <MainNavigationList isMobile onClick={() => setShowDrawer(false)} />
        </div>
      </Drawer>
      <IconButton onClick={() => setShowDrawer(true)} color='inherit'>
        <Menu />
      </IconButton>
    </React.Fragment>
  )
}
